// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"5866efd183546ef484d3","936":"7eab6bab73b0fedda216"}[chunkId] + ".js";
};